var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSelectMapType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0132 10.8333H16.0165C15.6612 10.8333 15.3665 10.5387 15.3665 10.1833V9.53333C15.3665 6.656 14.3438 5.63333 11.4665 5.63333H10.8165C10.4612 5.63333 10.1665 5.33867 10.1665 4.98333V3.98667C10.1665 1.23067 11.3972 0 14.1532 0H17.0132C19.7692 0 20.9998 1.23067 20.9998 3.98667V6.84667C20.9998 9.60267 19.7692 10.8333 17.0132 10.8333ZM16.4165 9.53333H17.0132C19.0498 9.53333 19.6998 8.88333 19.6998 6.84667V3.98667C19.6998 1.95 19.0498 1.3 17.0132 1.3H14.1532C12.1165 1.3 11.4665 1.95 11.4665 3.98667V4.58333C14.9998 5.23333 16.0165 6.25 16.4165 9.53333Z",
    fill: "#A4A4A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 20H10.75C14.5 20 16 18.5 16 14.75V10.25C16 6.5 14.5 5 10.75 5H6.25C2.5 5 1 6.5 1 10.25V14.75C1 18.5 2.5 20 6.25 20Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSelectMapType);
export default __webpack_public_path__ + "static/media/icon-select-map-type.9af9664cc3c47df2dc16bade9e9a6035.svg";
export { ForwardRef as ReactComponent };